<template>
  <img v-if="initFlag" class="avatar" :src="imgUrl" :onerror="defaultImg" alt="" :style="imgStyle">
</template>
<script>
// 头像组件
// prop {uid: 用户id; sex: 用户性别}
export default {
  name: 'Avatar',
  props: {
    uid: {
      required: true
    },
    sex: {
      required: false
    },
    size: {
      default: 0
    }
  },
  data() {
    return {
      imgUrl: '',
      defaultImg: '',
      defaultImgUrl: [
        require('../style/images/user_photo_female.png'),
        require('../style/images/user_photo_male.png')
      ],
      initFlag: false
    }
  },
  computed: {
    imgStyle() {
      if (this.size > 0) {
        return {
          width: this.size + 'px',
          height: this.size + 'px'
        }
      }
      return {}
    }
  },
  watch: {
    uid: {
      immediate: true,
      handler () {
        this.init()
      }
    },
    sex: {
      immediate: true,
      handler () {
        this.init()
      }
    }
  },
  methods: {
    init() {
      this.initFlag = false
      this.defaultImg = `this.onerror=null;src="${this.defaultImgUrl[(this.sex == null ? 1 : this.sex)]}"`
      this.imgUrl = global.$ComDomain.FileUri.photoUri + String(this.uid) + '?t=' + (new Date()).getTime()
      this.$nextTick(() => {
        this.initFlag = true
      })
    }
  },
  created() {
    this.init()
  }
}

</script>
<style scoped lang="less">
img.avatar {
  border-radius: 50%;
}

</style>



// WEBPACK FOOTER //
// src/commons/components/Avatar.vue